import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { dollarPrice, DollarPriceManipulationViewModel } from "./dollarPriceManipulation-viewModel"

export class DollarPriceManipulationView extends View<DollarPriceManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-A2EC75E1-63F2-41AE-AF6F-9E0802A86651"
    }
    loadHtml(): string {
        let element = require('./dollarPriceManipulation.html').default;
        let style = require('./dollarPriceManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set dollarPrice(v: ObservableArray<dollarPrice>) { this._dollarPrice = v; } public get dollarPrice(): ObservableArray<dollarPrice> { return this._dollarPrice;} private _dollarPrice: ObservableArray<dollarPrice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    
    requestDollarPriceCreation(){
        this.dataContext.requestDollarPriceCreation();
    }
    
    dirhamPrice(){
        this.dataContext.dirhamPrice();
    }
}
